import { useContext ,useState } from "react";
import { Context } from "../../Helpers/Auth";
import { DarkModeSwitch } from "react-toggle-dark-mode";
 
export default function Switcher() {
    // const [colorTheme, setTheme] = Theme();
    const {colorTheme, setTheme } = useContext(Context);
    const [darkSide, setDarkSide] = useState(
        colorTheme === "light" ? true : false
    );
 
    const toggleDarkMode = (checked) => {
        setTheme(colorTheme);
        setDarkSide(checked);
    };
 
    return (
        <>
            <DarkModeSwitch
                checked={darkSide}
                onChange={toggleDarkMode}
                size={16}
            />
        </>
    );
}